export function isPartner(brand) {
  let trimLowerBrand = (brand || "").trim().toLowerCase()
  return ['4moms', 'stokke'].includes(trimLowerBrand);
}


export function brandsFromPartner(brand) {
  let trimLowerBrand = (brand || "").trim().toLowerCase()
  return {
    stokke: ["Stokke","Babyzen"],
    "4moms": ["4moms"]
  }[trimLowerBrand]
}